// extracted by mini-css-extract-plugin
export default {"container":"Message_container__ubCmr","failed":"Message_failed__KiA74"};